import React, { PropsWithChildren } from 'react';
import { ApmRoute } from '@elastic/apm-rum-react';

interface IFasitApmRoute {
  path?: string | string[];
  exact?: boolean;
  active?: boolean;
}

export function FasitApmRoute(props: PropsWithChildren<IFasitApmRoute>) {
  const { path, exact, children, active = true } = props;

  return active ? <ApmRoute path={path} component={() => children as any} exact={exact} /> : null;
}
